<template>
  <v-container id="system-adjustment" fluid tag="section" class="d-flex flex-column flex-1">
    <v-row class="d-flex flex-column flex-1">
      <v-col cols="12" md="12" class="d-flex flex-column flex-1">
        <idc-component-adjustment-wrapper v-if="canRead" />
        <v-alert v-else type="error">
          Access denied
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'DashboardSystemAdjustment',
    components: {
      IdcComponentAdjustmentWrapper: () => import('@/components/idc/adjustment/Wrapper'),
    },
    props: {
      canRead: {
        type: Boolean,
        default: () => false,
      },
    },
  })
</script>
